import {mutations} from "@/modules/PanelSettings/store/mutations";
import {actions} from "@/modules/PanelSettings/store/actions";
import {getters} from "@/modules/PanelSettings/store/getters";

const state = {
    settings: {},
    settingsLoading: false,
    settingsSaving: false,
    settingsExpire: null,

    apiClients: [],

    blacklistedTableOptions: {
        page: 1,
        itemsPerPage: 20,
        search: '',
    },

    locales: [],
    localesLoading: false,
    localesExpire: null,

    serviceCreditPrices: [],
    serviceCreditTransactions: [],
    serviceCreditTableOptions: {
        page: 1,
        sortBy: ['created_at'],
        sortDesc: [true],
        itemsPerPage: 20,
        mustSort: true,
    },

    serviceCreditTableNextCursor: null,
    serviceCreditTablePrevCursor: null,

};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

